import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {MposDate} from 'app/blocks/util/mpos-date';

export interface IDunningMessageCode extends IBaseEntity {
    id?: number;

    code?: string;
}

export class DunningMessageCode extends BaseEntity implements IDunningMessageCode {
    public id?: number;

    public code?: string;

    constructor(dunningMessageCode?) {
        super();
        if (dunningMessageCode) {
            this.id = dunningMessageCode.id;

            this.code = dunningMessageCode.code;
        } else {
        }
    }

    get discriminator(): any {
        return this.code;
    }

    clone(): DunningMessageCode {
        return new DunningMessageCode(this);
    }
}
